import { Col } from 'react-bootstrap';
import AirbnbIcon from 'assets/images/icons/channels/airbnb.svg?react';
import { useTranslation } from 'react-i18next';
import { StarRatingsBreakdownContainer } from 'pages/property/reviews/sections/airbnbGuestReviews/overallAirbnbRatings/OverallAirbnbRatings.styles';
import StarProgressBar from 'components/progressBar/StarProgressBar';
import { normalizeKey } from 'utils/localeUtils';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { HostingQualitySubtitle } from '../HostingQualityWrapper.styles';
import { ReviewTagSpan } from './ReviewTags.styles';
import useAirbnbReviewTags from './useAirbnbReviewTags';

const ReviewTags = () => {
  const { reviewTags, isReviewTagsLoading } = useAirbnbReviewTags();
  const { t } = useTranslation();

  return (
    <Col xs={6}>
      <HostingQualitySubtitle>
        <b>{t('pageAnalytics.topNegativeReviewTags')}</b> <AirbnbIcon />
      </HostingQualitySubtitle>
      {isReviewTagsLoading && (
        <LoadingPlaceholder linesCount={1} width="100%" />
      )}
      {!isReviewTagsLoading && reviewTags?.topNegativeTags.length === 0 && (
        <span>{t('common.notApplicable')}</span>
      )}
      {reviewTags?.topNegativeTags && !isReviewTagsLoading && (
        <StarRatingsBreakdownContainer data-testid="star-ratings-breakdown">
          {reviewTags?.topNegativeTags.map(({ tag, count }) => {
            const now = (count / 5) * 100;

            return (
              <StarProgressBar
                key={tag}
                rating={count}
                label={
                  <ReviewTagSpan data-testid={`review-tag-${tag}`}>
                    {t(normalizeKey(`pageAnalytics.tags.${tag}`))}
                  </ReviewTagSpan>
                }
                now={now}
              />
            );
          })}
        </StarRatingsBreakdownContainer>
      )}
      <br />
      <HostingQualitySubtitle>
        <b>{t('pageAnalytics.topPositiveReviewTags')}</b> <AirbnbIcon />
      </HostingQualitySubtitle>

      {isReviewTagsLoading && (
        <LoadingPlaceholder linesCount={1} width="100%" />
      )}

      {!isReviewTagsLoading && reviewTags?.topPositiveTags.length === 0 && (
        <span>{t('common.notApplicable')}</span>
      )}

      {reviewTags?.topPositiveTags && !isReviewTagsLoading && (
        <StarRatingsBreakdownContainer data-testid="star-ratings-breakdown">
          {reviewTags?.topPositiveTags.map(({ tag, count }) => {
            const now = (count / 5) * 100;

            return (
              <StarProgressBar
                key={tag}
                rating={count}
                label={
                  <ReviewTagSpan data-testid={`review-tag-${tag}`}>
                    {t(normalizeKey(`pageAnalytics.tags.${tag}`))}
                  </ReviewTagSpan>
                }
                now={now}
              />
            );
          })}
        </StarRatingsBreakdownContainer>
      )}
    </Col>
  );
};

export default ReviewTags;
